module.exports = __webpack_public_path__ + "static/media/ru.2981aaa4.webp";